module.exports = __webpack_public_path__ + "img/upload-havedone.37a3ec7f.png";